'use client'

import { useEffect } from 'react'
import { hydrateReferral } from '../lib/hydrate-referral'
import useAttributionAllowed from '../hooks/useAttributionAllowed'

/**
 * Replays referral/advertiser attribution from the `pc_ref` cookie into localStorage, and
 * reports an Aiffiliate link's click once (lib/hydrate-referral.js).
 *
 * Rendered by the root layout OUTSIDE <LoadingIndicator>, and that placement is the point. This
 * used to run inside ClientHeaderWrapper, which sits inside the auth gate — so on an auth-gated
 * destination (e.g. `/a/create/<x>` → `/generate`) the header, and therefore the hydration, did
 * not mount until Firebase auth resolved. Out here it runs on first render of every page,
 * regardless of auth state, so the attribution is in localStorage before anything reads it.
 *
 * Renders nothing. hydrateReferral is idempotent (it never overwrites a stored affiliate and
 * reports each click once), so running it on every page, or twice, is harmless.
 *
 * With the strict consent switch on (NEXT_PUBLIC_STRICT_CONSENT), it waits until the visitor allows tracking, and runs
 * again when they do; off, `allowed` is always true and it runs once, as before.
 */
export default function ReferralHydrator() {
  const allowed = useAttributionAllowed()

  useEffect(() => {
    if (allowed) hydrateReferral()
  }, [allowed])

  return null
}
